module.exports = __webpack_public_path__ + "static/img/WisdomSiteJi.36ffe5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteJi.png
// module id = Q+gI
// module chunks = 12